/**
 * Sexy Hair Navigation Dropdown
 *
 * Initializes all `.sexyhair-nav-dropdown` elements on the page with:
 * - Click toggle
 * - Click-outside close
 * - Escape key close
 * - Hover open/close (desktop)
 * - Keyboard support (Enter, Space, ArrowDown)
 *
 * Re-runs init on `shopify:section:load` and tears down instances on
 * `shopify:section:unload` so theme-editor reloads of the header don't leak
 * scroll listeners or stack global click/Escape handlers.
 */
(function () {
  /** Live list of active dropdown instances (mutated across section reloads). */
  const instances = [];

  function initContainer(container) {
    if (instances.some((inst) => inst.container === container)) return;

    const trigger = container.querySelector('.sexyhair-nav-dropdown__trigger');
    const menu = container.querySelector('.sexyhair-nav-dropdown__menu');
    if (!trigger || !menu) return;

    // Mega-menu variant uses `position: fixed; top: var(--header-height)`, which doesn't
    // account for the announcement bar pushing the header down at scroll=0. Track the
    // header's actual viewport-bottom while open so the menu stays flush regardless of
    // scroll position. Simple dropdowns use `position: absolute; top: 100%` and don't need this.
    const isMega = !menu.classList.contains('sexyhair-nav-dropdown__menu--simple');
    const stickyHeader = isMega ? document.querySelector('.sexyhair-section-header') : null;

    function syncTopToHeader() {
      if (!stickyHeader) return;
      menu.style.top = `${stickyHeader.getBoundingClientRect().bottom}px`;
    }

    let isOpen = false;

    function open() {
      isOpen = true;
      if (stickyHeader) {
        syncTopToHeader();
        window.addEventListener('scroll', syncTopToHeader, { passive: true });
      }
      menu.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      container.classList.add('is-open');
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      if (stickyHeader) {
        window.removeEventListener('scroll', syncTopToHeader);
      }
      menu.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
      container.classList.remove('is-open');
    }

    function toggle() {
      isOpen ? close() : open();
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggle();
    });

    container.addEventListener('mouseenter', function () {
      open();
    });
    container.addEventListener('mouseleave', function () {
      close();
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!isOpen) open();
      }
    });

    instances.push({ container: container, close: close });
  }

  function init(root) {
    (root || document).querySelectorAll('.sexyhair-nav-dropdown').forEach(initContainer);
  }

  function teardown(root) {
    for (let i = instances.length - 1; i >= 0; i--) {
      const inst = instances[i];
      if (!root || root.contains(inst.container) || !document.contains(inst.container)) {
        inst.close();
        instances.splice(i, 1);
      }
    }
  }

  // Global listeners are registered once at module load; they read from the
  // live `instances` array so section reloads don't need to re-register them.
  document.addEventListener('click', function (e) {
    instances.forEach(function (inst) {
      if (!inst.container.contains(e.target)) {
        inst.close();
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      instances.forEach(function (inst) {
        inst.close();
      });
    }
  });

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    teardown(e.target);
  });

  init();
})();
